import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Sectors from "@/components/Sectors";
import Approach from "@/components/Approach";
import WhyUs from "@/components/WhyUs";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-white">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Sectors />
        <Approach />
        <WhyUs />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
